export default "__VITE_ASSET__BL1PourP__"